import { EditEmployeeResponseDTO } from '@/core/dto/psychosocial-report';
import type { EditEmployeeResponse } from '@/types/Psychosocial';

export class EditEmployeeMapper {
	constructor(private readonly data: EditEmployeeResponseDTO) {}

	toDomain(): EditEmployeeResponse {
		return {
			employee: {
				id: this.data.employee.id,
				name: this.data.employee.name,
				email: this.data.employee.email,
				employee_code: this.data.employee.employee_code,
				company_id: this.data.employee.company_id,
				gender: this.data.employee.gender,
				role: this.data.employee.role,
				admission_date: this.data.employee.admission_date,
				created_at: this.data.employee.created_at,
				updated_at: this.data.employee.updated_at,
				deleted_at: this.data.employee.deleted_at
			}
		};
	}
}
